import type { FaireThemeEntity } from "../../entity_types/theme";

export const zero_waste_clean_beauty: FaireThemeEntity = {
  token: "zero-waste-clean-beauty",
  type: "theme",
  name: "Zero-Waste Clean Beauty",
  description: "Sustainable and toxin-free personal care essentials that swap traditional plastic packaging for high-performance, eco-friendly alternatives.",
  teaser: "Your profile highlights 'eco-friendly' and 'sustainable' as key quality signals. You lean towards non-toxic and vegan products that align with a premium clothing and lifestyle boutique vibe.",
  detail: "The payload includes a solid Conditioner Bar, which is a key zero-waste beauty staple, along with organic shower gels and hair treatments that avoid parabens and sulfates.",
  bgColor: "#D4E8E8",
  tileBgColor: "#39676b",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_vtv9x9xap8",
    "p_5nut65sesg",
    "p_tp967eew7r",
    "p_uxf6nfz53h",
    "p_5wzhpg3fbg",
    "p_6u6en7g74g",
    "p_c2z7ruafqr",
    "p_5ngtaerd9j",
    "p_p6warpuptn",
    "p_vku86j73uh",
    "p_qraervnhh3",
    "p_g9ju46vmfb",
    "p_kd383pnvz6",
    "p_sp458mswhv",
    "p_huw2gx2h7y",
    "p_kk73dtwgbj",
    "p_p6ryxeb6js",
    "p_mpud6tczqj",
    "p_psbcpv27wq",
    "p_53myskjssy",
    "p_d77t968g3r",
    "p_ea4336dzwz",
    "p_z49y2xsp3v",
    "p_4sryce635n",
    "p_ngvhmsdzd7",
    "p_2p9kxdxkwa",
    "p_y6jpp679mv",
    "p_j349sdjkfh",
    "p_868dqutqmx",
    "p_p564k34s5k",
    "p_g8tp4283yy",
    "p_m2d53v8p7f",
    "p_eu8eapydrv",
    "p_snaf5qpdnc",
    "p_je79wxss9z",
    "p_eurpanhpk9",
    "p_s8u88bjaqn",
    "p_jv32atw79q",
    "p_q6px4tywds",
    "p_4e7u473ct9",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
